<template>
  <div class="sidebar" :data-color="activeColor" :data-image="backgroundImage" :style="sidebarStyle">
    <core-version :is-small="isSmall" :tooltip="false" :redirect-if-is-small="true"></core-version>
    <div class="sidebar-wrapper" :style="isSmall ? 'width: 90px' : ''">
      <slot name="content"></slot>
      <md-list class="nav" style="height: 95%">
        <!--By default vue-router adds an active class to each route link. This way the links are colored when clicked-->
        <slot>
          <sidebar-link v-for="(link, index) in sidebarLinks" :key="link.name + index" :to="link.path" :link="link">
          </sidebar-link>
        </slot>
      </md-list>
    </div>
  </div>
</template>
<script>
import SidebarLink from "./SidebarLink.vue";
import CoreVersion from "../CoreVersion";

export default {
  components: {
    CoreVersion,
    SidebarLink,
  },
  props: {
    title: {
      type: String,
      default: "Saman",
    },
    backgroundImage: {
      type: String,
      default: require("@/assets/img/sidebar-2.jpg"),
    },
    activeColor: {
      type: String,
      default: "k-primary-800",
      validator: (value) => {
        let acceptedValues = ["", "purple", "blue", "green", "orange", "red", "k-primary-800"];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
    isSmall: {
      type: Boolean,
      default: false,
    },
    addVersion: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      versionLoaded: false,
      showVersionDetails: false,
    };
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  computed: {
    sidebarStyle() {
      return {
        backgroundColor: `#14387f`,
      };
    },
  },
};
</script>
<style>
@media screen and (min-width: 991px) {
  .nav-mobile-menu {
    display: none;
  }
}
.shrunk-side-bar .logo:after {
  display: none;
}
</style>
